import {
  DEFAULT_LIST_ORDER,
  LIVE_INPUT_ORDER_BY_FIELDS,
  listLiveInputsRequestSchema,
} from '@customTypes/cloudmix/liveInputs'
import { LiveInputsTableWrapper } from '@features/liveInputs/components/LiveInputsTableWrapper'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { withListHydration } from '@lib/listState/withListHydration'

const LiveInputRoute = () => <LiveInputsTableWrapper />

const routerSchema = listLiveInputsRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/liveInputs/')({
  component: LiveInputRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {
      defaultSort: [DEFAULT_LIST_ORDER],
      allowedOrderByFields: LIVE_INPUT_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Live Inputs',
  }),
})
